<template>
  <div class="TwoColumnRow">
    <div class="title" v-if="isShowTitle">
        <span>{{dataTitle}}</span>
        <span  v-show="hasMore===1" class="more" @click="toMore">更多<img src="@/assets/icon_jump.png"></span>
    </div>
    <div class="list">
        <div class="item" v-for="(item, key) in list" :key="key" @click="clickOpen(item)">
            <div class="header">
                <img :src="item.icon">
                <div class="playback">
                    <img src="@/assets/icon_book.png">
                    <div>{{ randomNumber() }}人正在学习</div>
                </div>
            </div>
            <div class="content">
                <div class="title">{{item.title}}</div>
                <div v-show="item.comment" class="comment">{{item.comment|commentFilter}}</div>
                <!-- <div v-if="item.price">
                    <span class="price">¥{{item.price | money}}</span>
                    <span class="old_price">¥{{item.old_price | money}}</span>
                </div> -->
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { cblockItem } from '@/api/app'
import { money } from '@/utils/index'
import { substring } from '@/utils/index'
export default {
  name: 'TwoColumnRow',
  props: {
    isShowTitle: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Number,
      default: 1
    },
    dataId: {
      default: null
    },
    dataTitle: {
      type: String,
      default: null
    },
    list: {
      type: Array,
      default: () =>{
        return []
      }
    }
  },
  filters: {
    money,
    commentFilter(comment) {
      return substring(comment, 10, true)
    }
  },
  data () {
    return {
    }
  },
  created() {
  },
  methods: {
    toMore: function(){
      this.$emit('clickMore', this.dataId, this.dataTitle);
    },
    clickOpen: function(item){
      cblockItem(item, this)
    },
    randomNumber(){
      return parseInt(Math.random()*4900)+100
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.TwoColumnRow{
  color: #333;
  padding: 8px 16px;
}
.TwoColumnRow>.title{
    display: flex;
    justify-content:space-between;
    font-size: 16px;
    font-weight:bold;
    padding: 8px 0 13px 0;
}
.TwoColumnRow .title .more{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 100;
    color: #AAA;
}
.TwoColumnRow .title img{
    width: 16px;
}
.TwoColumnRow .list{
  display: flex;
  flex-wrap: wrap;
  justify-content:space-between;
}
.TwoColumnRow .list .item{
  width: 48%;
  background-color: #fff;
  padding-bottom: 6px;
  border-radius: 16px;
  margin-bottom: 10px;
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.06);
}
.TwoColumnRow .list .item .header{
    position: relative;
}
.TwoColumnRow .list .item .header > img{
    width: 100%;
    display: inherit;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}
.TwoColumnRow .list .item .header .playback{
    width: 100%;
    text-align: left;
    background-color: rgba(0,0,0,0.15);
    position: absolute;
    bottom: 0;
    padding: 5px 0;
    color: #fff;
    font-size: 12px;
    font-weight:bold;
    display: flex;
    align-items: center;
}
.TwoColumnRow .list .item .header .playback img{
  width: 14px;
  margin: 0 5px;
}
.TwoColumnRow .list .item .content{
    padding: 0 8px;
    text-align: left;
}
.TwoColumnRow .list .item .title{
    height: 40px;
    line-height: 18px;
    font-size: 16px;
    padding: 12px 0 4px 0;
    color: #3F3F3F;
}
.TwoColumnRow .list .item .comment{
    font-size: 13px;
    color: #999999;
    margin-bottom: 6px;
}
.TwoColumnRow .list .item .price{
    font-size: 12px;
    color: #43ADFF;
}
.TwoColumnRow .list .item .old_price{
    font-size: 12px;
    color: #999999;
    text-decoration:line-through;
    margin-left: 6px;
}
</style>
